// extracted by mini-css-extract-plugin
export var askAiIcon = "_jv-9";
export var container = "_jv-0";
export var groupSeparator = "_jv-a";
export var highlight = "_jv-4";
export var resultIcon = "_jv-5";
export var resultItem = "_jv-7";
export var resultSubtitle = "_jv-3";
export var resultTitle = "_jv-2";
export var resultsList = "_jv-1";
export var searchGroup = "_jv-6";
export var selected = "_jv-8";